import React, { useEffect, useState } from "react";
import { getDocs, getDoc, arrayUnion, addDoc, updateDoc, deleteDoc, doc, collection } from "firebase/firestore"; // Use getDocs for collections
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { publicationsRef, researchProjectsRef, researchDomainsRef, doctoralScholarsRef, postGraduateStudentsRef, projectScholarsRef, facultyInChargeRef, underGraduateStudentsRef, graduatePhDStudentsRef, pastPostGradStudentsRef, pastProjectScholarsRef, collaborationsRef, labFacilityRef, photosRef, homeRef, db } from '../utils/firebaseConfig';

const FirebaseContext = React.createContext(null);

export const useFirebase = () => React.useContext(FirebaseContext);

export const FirebaseProvider = (props) => {
    const [publications, setPublications] = useState(null);
    const [publicationsKeys, setPublicationKeys] = useState(null);
    const [researchProjects, setResearchProjects] = useState(null);
    const [researchProjectsKeys, setResearchProjectsKeys] = useState(null);
    const [researchDomains, setResearchDomains] = useState(null);
    const [researchDomainsKeys, setResearchDomainsKeys] = useState(null);

    const [pastPostGradStudents, setpastPostGradStudents] = useState(null);
    const [pastProjectScholars, setPastProjectScholars] = useState(null);

    const [doctoralScholars, setDoctoralScholars] = useState(null);
    const [postGraduateStudents, setPostGraduateStudents] = useState(null);
    const [projectScholars, setProjectScholars] = useState(null);
    const [underGraduateStudents, setUnderGraduateStudents] = useState(null);
    const [graduatePhDStudents, setGraduatePhDStudents] = useState(null);
    const [facultyInCharge, setFacultyInCharge] = useState(null);

    const [collaborations, setCollaborations] = useState(null);
    const [collaborationsKeys, setCollaborationsKeys] = useState(null);

    const [labFacility, setLabFacility] = useState(null);
    const [photos, setPhotos] = useState(null);

    const [homeAbout, setHomeAbout] = useState(null);
    const [homeVision, setHomeVision] = useState(null);
    const [homeObjective, setHomeObjective] = useState(null);

    //======================================
    //PUBLICATIONS
    //======================================

    const addPublication = async (arrayName, newValue) => {
        try {
            const publicationDocRef = doc(publicationsRef, "Publications");
            const publicationSnapshot = await getDoc(publicationDocRef);

            if (publicationSnapshot.exists()) {
                // Retrieve the existing publications array
                const currentArray = publicationSnapshot.data()[arrayName] || [];

                // Prepend the new publication to the beginning of the array
                const updatedArray = [newValue, ...currentArray];

                await updateDoc(publicationDocRef, {
                    [arrayName]: updatedArray
                });

                console.log("Document updated successfully, added to the top");
            } else {
                console.error("No publication document found.");
            }
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const editPublication = async (arrayName, index, newValue) => {
        try {
            const publicationDocRef = doc(publicationsRef, "Publications");
            const docSnapshot = await getDoc(publicationDocRef);

            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const publicationsArray = data[arrayName]; // Get the array by key

                if (index >= 0 && index < publicationsArray.length) {
                    publicationsArray[index] = newValue; // Modify the value at the specified index

                    await updateDoc(publicationDocRef, {
                        [arrayName]: publicationsArray, // Update the modified array in Firestore
                    });

                    console.log("Document updated successfully");
                } else {
                    console.error("Invalid index");
                }
            } else {
                console.error("No such document!");
            }
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const deletePublication = async (arrayName, index) => {
        try {
            const publicationDocRef = doc(publicationsRef, "Publications");
            const docSnapshot = await getDoc(publicationDocRef);

            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const publicationsArray = data[arrayName];

                if (index >= 0 && index < publicationsArray.length) {
                    publicationsArray.splice(index, 1); // Remove the item at the specified index

                    await updateDoc(publicationDocRef, {
                        [arrayName]: publicationsArray, // Update the modified array in Firestore
                    });

                    console.log("Document updated successfully");
                } else {
                    console.error("Invalid index");
                }
            } else {
                console.error("No such document!");
            }
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    //======================================
    //======================================

    //======================================
    //PEOPLE
    //======================================
    const addPeople = async (newValue, category) => {
        try {
            const docRef = await addDoc(collection(db, `people/category/${category}`), newValue)
            console.log("doc with ID : ", docRef.id);
            console.log("Document updated successfully");
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const deletePeople = async (category, id) => {
        try {
            const collectionName = `people/category/${category}`;
            const docRef = doc(db, collectionName, id);
            await deleteDoc(docRef);
            console.log("Document deleted with id : ", id);
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const editPeople = async (category, docId, newData) => {
        try {
            const collectionName = `people/category/${category}`;
            const docRef = doc(db, collectionName, docId);
            await updateDoc(docRef, newData);
            console.log('updated doc with id : ', docId);
        } catch (e) {
            console.error("Error updating the document: ", e);
        }
    }

    const uploadImage = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                reject("No file provided");
            }

            const storage = getStorage();  // Get the storage service from Firebase
            const storageRef = ref(storage, `images/${Date.now()}_${file.name}`);  // Create a unique reference for the image

            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    // Progress tracking can be handled here (optional)
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done`);
                },
                (error) => {
                    // Handle upload error
                    reject(error);
                },
                () => {
                    // On successful upload, get the download URL
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        resolve(downloadURL);
                    }).catch((error) => reject(error));
                }
            );
        });
    };

    //======================================
    //PAST SCHOLARS
    //======================================
    const addPastScholars = async (newValue, category) => {
        try {
            const docRef = await addDoc(collection(db, `pastScholars/Scholars/${category}`), newValue)
            console.log("doc with ID : ", docRef.id);
            console.log("Document updated successfully");
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const deletePastScholars = async (category, id) => {
        try {
            const collectionName = `pastScholars/Scholars/${category}`;
            const docRef = doc(db, collectionName, id);
            await deleteDoc(docRef);
            console.log("Document deleted with id : ", id);
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const editPastScholars = async (category, docId, newData) => {
        try {
            const collectionName = `pastScholars/Scholars/${category}`;
            const docRef = doc(db, collectionName, docId);
            await updateDoc(docRef, newData);
            console.log('updated doc with id : ', docId);
        } catch (e) {
            console.error("Error updating the document: ", e);
        }
    }

    //======================================
    //RESEARCH PROJECTS
    //======================================

    const addResearchProject = async (arrayName, newValue) => {
        try {
            const researchProjectDocRef = doc(researchProjectsRef, "ResearchProjects");
            const researchProjectSnapshot = await getDoc(researchProjectDocRef);

            if (researchProjectSnapshot.exists()) {
                const currentArray = researchProjectSnapshot.data()[arrayName] || [];
                const updatedArray = [newValue, ...currentArray];

                await updateDoc(researchProjectDocRef, {
                    [arrayName]: updatedArray
                });

                console.log("Research project added successfully");
            } else {
                console.error("No research project document found.");
            }
        } catch (e) {
            console.error("Error adding research project: ", e);
        }
    };

    const editResearchProject = async (arrayName, index, newValue) => {
        try {
            const researchProjectDocRef = doc(researchProjectsRef, "ResearchProjects");
            const docSnapshot = await getDoc(researchProjectDocRef);

            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const projectsArray = data[arrayName];

                if (index >= 0 && index < projectsArray.length) {
                    projectsArray[index] = newValue;

                    await updateDoc(researchProjectDocRef, {
                        [arrayName]: projectsArray,
                    });

                    console.log("Research project updated successfully");
                } else {
                    console.error("Invalid index for editing project");
                }
            } else {
                console.error("No research project document found.");
            }
        } catch (e) {
            console.error("Error editing research project: ", e);
        }
    };

    const deleteResearchProject = async (arrayName, index) => {
        try {
            const researchProjectDocRef = doc(researchProjectsRef, "ResearchProjects");
            const docSnapshot = await getDoc(researchProjectDocRef);

            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const projectsArray = data[arrayName];

                if (index >= 0 && index < projectsArray.length) {
                    projectsArray.splice(index, 1);

                    await updateDoc(researchProjectDocRef, {
                        [arrayName]: projectsArray,
                    });

                    console.log("Research project deleted successfully");
                } else {
                    console.error("Invalid index for deleting project");
                }
            } else {
                console.error("No research project document found.");
            }
        } catch (e) {
            console.error("Error deleting research project: ", e);
        }
    };

    // ===========================================
    // Home Page
    // ===========================================

    const addSection = async (sectionName, newValue) => {
        try {
            const homeDocRef = doc(homeRef, "data");  // Points to "data" document in the "home" collection
            const homeSnapshot = await getDoc(homeDocRef);
    
            if (homeSnapshot.exists()) {
                const currentArray = homeSnapshot.data()[sectionName] || [];
                const updatedArray = [...currentArray, newValue];
    
                await updateDoc(homeDocRef, {
                    [sectionName]: updatedArray
                });
    
                console.log(`${sectionName} section updated successfully`);
            } else {
                console.error("No 'data' document found in the 'home' collection.");
            }
        } catch (e) {
            console.error(`Error adding to ${sectionName}: `, e);
        }
    };
    
    // Function to edit an existing item in a specified section (array)
    const editSection = async (sectionName, index, newValue) => {
        try {
            const homeDocRef = doc(homeRef, "data");
            const docSnapshot = await getDoc(homeDocRef);
    
            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const sectionArray = data[sectionName] || [];
    
                if (index >= 0 && index < sectionArray.length) {
                    sectionArray[index] = newValue;
    
                    await updateDoc(homeDocRef, {
                        [sectionName]: sectionArray,
                    });
    
                    console.log(`${sectionName} section updated successfully`);
                } else {
                    console.error("Invalid index for editing section");
                }
            } else {
                console.error("No 'data' document found in the 'home' collection.");
            }
        } catch (e) {
            console.error(`Error editing ${sectionName} section: `, e);
        }
    };
    
    // Function to delete an item from a specified section (array)
    const deleteSection = async (sectionName, index) => {
        try {
            const homeDocRef = doc(homeRef, "data");
            const docSnapshot = await getDoc(homeDocRef);
    
            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const sectionArray = data[sectionName] || [];
    
                if (index >= 0 && index < sectionArray.length) {
                    sectionArray.splice(index, 1);
    
                    await updateDoc(homeDocRef, {
                        [sectionName]: sectionArray,
                    });
    
                    console.log(`${sectionName} section item deleted successfully`);
                } else {
                    console.error("Invalid index for deleting section");
                }
            } else {
                console.error("No 'data' document found in the 'home' collection.");
            }
        } catch (e) {
            console.error(`Error deleting item in ${sectionName} section: `, e);
        }
    };

    //======================================
    //PHOTOS
    //======================================

    const addPhoto = async (photo, collectionName) => {
        try {
            const newValue = {link: photo};
            const docRef = await addDoc(collection(db, collectionName), newValue)
            console.log("doc with ID : ", docRef.id);
            console.log("Document updated successfully");

        } catch (e) {
            console.error("Error updating document: ", e);
        }
    };

    const deletePhoto = async (id, collectionName) => {
        try {
            const docRef = doc(db, collectionName, id);
            await deleteDoc(docRef);
            console.log("Document deleted with id : ", id);
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    }

    //======================================
    //LAB FACILITY
    //======================================

    const addLabPhoto = async (data) => {
        try {
            console.log(data);
            const docRef = await doc(db, "labFacility", `${data.imageCategory}`);
            console.log("doc with ID : ", docRef.id);
            await updateDoc(docRef, {
                description: arrayUnion(data.description),
                links: arrayUnion(data.imageUrl),
            });
            console.log("Document updated successfully");
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    }

    const removeLabPhoto = async (idx, collectionName) => {
        try {
            const docRef = doc(db, "labFacility", collectionName);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                const {description, links, subtitle} = data;
                if (idx >= 0 && idx < description.length) {
                    description.splice(idx, 1);
                    links.splice(idx, 1);
                    await updateDoc(docRef, {
                        description,
                        links,
                        subtitle
                    });
                } else {
                    console.log("element is out of range");
                }
            }
            console.log("Document deleted with id : ", docRef.id);
        } catch (e) {
            console.error("Error updating document: ", e);
        }
    }

    const editLabPhoto = async (data, data_idx) => {
        try{
            const docRef = doc(db, "labFacility", data.imageCategory);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const doc_data = docSnap.data();
                const {description, imageCategory, imageUrl} = data;
                if (data_idx >= 0 && data_idx < doc_data.description.length) {
                    if (description) {
                        doc_data.description[data_idx] = description;
                    }
                    if (imageUrl) {
                        doc_data.links[data_idx] = imageUrl;
                    }
                    await updateDoc(docRef, {
                        description: doc_data.description,
                        links : doc_data.links
                    });
                } else {
                    console.log("element is out of range");
                }
            }
        } catch (e) {
            console.error("Error updating the document: ",e);
        }
    }

    //======================================
    //======================================

    useEffect(() => {
        getDocs(publicationsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setPublicationKeys(data[0].headings);
                setPublications(data[1]);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(researchProjectsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setResearchProjectsKeys(data[0].headings);
                setResearchProjects(data[1]);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(researchDomainsRef)
            .then((snapshot) => {
                const researchDomainsData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    title: doc.data().title || 'Untitled',  // Fallback if no title
                    description: doc.data().description || 'No description available', // Fallback for missing description
                    mediatype: doc.data().mediatype || 'image', // Default media type if not provided
                    mediaurl: doc.data().mediaurl || []  // Ensure mediaurl is available as an array
                }));
                setResearchDomains(researchDomainsData);
                setResearchDomainsKeys(researchDomainsData.map(project => project.title)); // Extract titles as keys
            })
            .catch((error) => {
                console.error("Error getting research domains:", error);
            });

        getDocs(graduatePhDStudentsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                // setPastScholarsKeys(data[0].headings);
                setGraduatePhDStudents(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
        getDocs(pastPostGradStudentsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                // setPastScholarsKeys(data[0].headings);
                setpastPostGradStudents(data);
                // console.log(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
        getDocs(pastProjectScholarsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                // setPastScholarsKeys(data[0].headings);
                setPastProjectScholars(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(doctoralScholarsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setDoctoralScholars(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
        getDocs(postGraduateStudentsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                // setPastScholarsKeys(data[0].headings);
                setPostGraduateStudents(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
        getDocs(projectScholarsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setProjectScholars(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
        getDocs(underGraduateStudentsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setUnderGraduateStudents(data);
            })
            .catch((error) => {
                console.error("Error getting underGraduateStudents:", error);
            });

        getDocs(facultyInChargeRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setFacultyInCharge(data[0]);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(collaborationsRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCollaborationsKeys(data[1].headings);
                setCollaborations(data[0]);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(labFacilityRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setLabFacility(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(photosRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setPhotos(data);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });

        getDocs(homeRef)
            .then((snapshot) => {
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                setHomeAbout(data[0].homeAbout);
                setHomeVision(data[0].homeVision);
                setHomeObjective(data[0].homeObjective);
            })
            .catch((error) => {
                console.error("Error getting documents:", error);
            });
    }, []);

    return (
        <FirebaseContext.Provider value={{
            publications,
            publicationsKeys,
            researchProjects,
            researchProjectsKeys,
            researchDomains,
            researchDomainsKeys,
            doctoralScholars,
            postGraduateStudents,
            projectScholars,
            underGraduateStudents,
            facultyInCharge,
            graduatePhDStudents,
            pastPostGradStudents,
            pastProjectScholars,
            collaborations,
            collaborationsKeys,
            labFacility,
            photos,
            homeAbout,
            homeVision,
            homeObjective,

            labFacility,
            addLabPhoto,
            removeLabPhoto,
            editLabPhoto,

            photos, 
            addPhoto,
            deletePhoto,
            

            addPublication,
            editPublication,
            deletePublication,

            addPeople,
            deletePeople,
            editPeople,
            uploadImage,

            addPastScholars,
            editPastScholars,
            deletePastScholars,

            addResearchProject,
            editResearchProject,
            deleteResearchProject,

            addSection,
            editSection,
            deleteSection,
        }}>
            {props.children}
        </FirebaseContext.Provider>
    );
};
